export class GameConfig {
  private type;
  private drawId;
  private loading;

  constructor() {
    this.type = 'prize';
    this.drawId = '';
    this.loading = false;
  }

  setType(value) {
    this.type = value;
  }

  getType() {
    return this.type;
  }

  setDrawId(value) {
    this.drawId = value;
  }

  getDrawId() {
    return this.drawId;
  }

  setLoading(loading) {
    this.loading = loading;
  }

  isLoading() {
    return this.loading;
  }
}
